import { useUIStore } from '@/store/uiStore';
import type { Lente } from '@/types';
import styles from './LenteToolbar.module.css';

const LENTES: Record<Lente, { label: string; ico: string; explain: string }> = {
  cliente: {
    label: 'Cliente',
    ico: '🧑‍💼',
    explain:
      'Solo hitos Clave (los visibles al cliente). En Compromisos filtra a los marcados como hito visible.',
  },
  gerencia: {
    label: 'Gerencia',
    ico: '📊',
    explain:
      'Solo hitos Formales (gobernanza interna). En Compromisos filtra a los de iniciativas con hitos formales.',
  },
  interno: {
    label: 'Interno',
    ico: '🛠️',
    explain:
      'Conjunto completo de hitos y compromisos. Vista de gestión y seguimiento operativo.',
  },
};

export function LenteToolbar() {
  const lente = useUIStore((s) => s.lente);
  const setLente = useUIStore((s) => s.setLente);
  return (
    <div className={styles.wrap}>
      <span className={styles.label}>Vista para:</span>
      <div className={styles.seg}>
        {(Object.keys(LENTES) as Lente[]).map((k) => (
          <button
            key={k}
            className={`${styles.btn} ${lente === k ? styles.active : ''}`}
            onClick={() => setLente(k)}
          >
            <span className={styles.ico}>{LENTES[k].ico}</span>
            {LENTES[k].label}
          </button>
        ))}
      </div>
      <span className={styles.explain}>{LENTES[lente].explain}</span>
    </div>
  );
}
